<template>
  <v-card>
    <v-card-title class="headline colorHeadlineStandard" primary-title> {{ $t('label.InitialSettings') }} </v-card-title>
    <v-card-text>
      <v-form ref="initForm">
        <v-row>
          <v-col class="mt-5">
            <v-select
              v-model="initialSettings.language"
              :items="listLanguages"
              item-text="text"
              item-value="value"
              :label="$t('label.language')"
              @change="changeLanguage"
              hide-details
            />
            <v-select
              v-model="initialSettings.formatDate"
              :items="listDateFormats"
              item-text="text"
              item-value="value"
              :label="$t('label.formatDate')"
              hide-details
            />
            <v-select
              v-model="initialSettings.formatTime"
              :items="listTimeFormats"
              item-text="text"
              item-value="value"
              :label="$t('label.formatTime')"
              hide-details
            />
            <v-select
              v-model="initialSettings.firstDay"
              :items="listFirstDayOfWeek"
              item-text="text"
              item-value="value"
              :label="$t('label.firstDayOfWeek')"
              hide-details
            />
            <v-text-field v-model="initialSettings.area" :rules="[ruleRequired]" :label="$t('label.presetAreaName')" hide-details />
            <v-text-field
              v-model="initialSettings.gatehouse"
              :rules="[ruleRequired]"
              :label="$t('label.presetWorkplaceName')"
              hide-details
            />
            <v-text-field v-model="initialSettings.email" :rules="[ruleRequired]" :label="$t('label.email')" hide-details />
          </v-col>
        </v-row>
        <!--TODO: Doplnit licencne podmienky-->
        <v-row v-if="false">
          <v-col cols="1">
            <v-checkbox class="ma-0" v-model="initialSettings.terms" />
          </v-col>
          <v-col cols="11">
            {{ $t('label.iAgree') }}
            <v-btn text small @click="termsLoad"> {{ $tc('label.termsAndConditions', 2) }} </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="colorSave" block @click="saveInitialSettings">{{ $t('btn.save') }}</v-btn>
    </v-card-actions>
    <!-------------Dialogs------------------------------------>
    <v-dialog v-model="dialogDownloadClient" persistent max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.downloadInstallFile') }}
          <v-spacer />
          <v-icon large @click="((dialogDownloadClient = false), $emit('confirmed'))">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <h2 class="pa-2">{{ $t('msg.clientInstall') }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkWindows">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="($emit('confirmed'), (dialogDownloadClient = false))">
                  {{ $t('btn.downloadWindows') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkMacIntel">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="($emit('confirmed'), (dialogDownloadClient = false))">
                  {{ $t('btn.downloadMacOSintel') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkMacAppleSilicon">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="($emit('confirmed'), (dialogDownloadClient = false))">
                  {{ $t('btn.downloadMacOSapple') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTerms" persistent max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.termsAndConditions') }}
          <v-spacer />
          <v-icon large @click="dialogTerms = false">{{ mdiClose }}</v-icon>
        </v-card-title>

        <v-sheet max-height="480" style="overflow: auto">
          <v-card-text>
            <div v-html="terms" />
          </v-card-text>
        </v-sheet>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiTranslate, mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'infoDialog',
  data: () => ({
    initialSettings: {
      language: 'en',
      formatDate: 'DD.MM.YYYY',
      formatTime: 'HH:mm',
      firstDay: 1,
      terms: false,
      area: 'Main office',
      idCard: '',
      passport: '',
      driversLicense: '',
      gatehouse: 'Gatehouse',
      defaultGatehouse: '',
      email: '',
      timezone: '',
    },
    terms: '',
    workplaceUUID: '',
    dialogDownloadClient: false,
    dialogTerms: false,
    clientDownloadServerURL: '',
    clientDownloadLinkWindows: '',
    clientDownloadLinkMacIntel: '',
    clientDownloadLinkMacAppleSilicon: '',
    listLanguages: [],
    listDateFormats: [
      { text: '21.12.2021', value: 'DD.MM.YYYY' },
      { text: '21/12/2021', value: 'DD/MM/YYYY' },
      { text: '21-12-2021', value: 'DD-MM-YYYY' },
      { text: '2021-12-21', value: 'YYYY-MM-DD' },
      { text: '2021/12/21', value: 'YYYY/MM/DD' },
    ],
    listTimeFormats: [
      { text: '16:23', value: 'HH:mm' },
      { text: '04:23pm', value: 'hh:mmA' },
    ],
    mdiTranslate: mdiTranslate,
    mdiClose: mdiClose,
  }),
  computed: {
    listFirstDayOfWeek: function () {
      return [
        { text: this.$i18n.t('label.sunday'), value: 0 },
        { text: this.$i18n.t('label.monday'), value: 1 },
      ];
    },
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
  },
  mounted() {
    // TODO: Doplnit licencne podmienky
    this.initialSettings.terms = true;
    this.listLanguagesLoad();
    const form: any = this.$refs.initForm;
    form.validate();
  },
  methods: {
    saveInitialSettings() {
      const form: any = this.$refs.initForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
        return;
      }
      this.initialSettings.idCard = this.$i18n.t('label.idCard').toString();
      this.initialSettings.passport = this.$i18n.t('label.passport').toString();
      this.initialSettings.driversLicense = this.$i18n.t('label.driversLicense').toString();
      this.initialSettings.defaultGatehouse = this.$i18n.t('label.gatehouse').toString();
      this.initialSettings.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      axios
        .put('/api/v1/initialsettings', this.initialSettings)
        .then((response) => {
          if (response.data.message == 'termsNotAccepted') {
            this.$store.commit('globalMessage', this.$i18n.t('msg.mustAcceptTerms'));
            return;
          }
          if (response.data.message == 'emptyGatehose') {
            this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
            return;
          }
          if (response.data.message == 'emptyArea') {
            this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
            return;
          }
          if (response.data.message == 'invalidEmail') {
            this.$store.commit('globalMessage', this.$i18n.t('msg.emailNotValid'));
            return;
          }
          this.createWorkplace();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listLanguagesLoad() {
      axios
        .get('/api/v1/languages')
        .then((response) => {
          this.listLanguages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    termsLoad() {
      axios
        .get(`/api/terms/${this.initialSettings.language}`)
        .then((response) => {
          this.terms = response.data;
          this.dialogTerms = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    changeLanguage() {
      this.$i18n.locale = this.initialSettings.language;
      this.$vuetify.lang.current = this.initialSettings.language;
      this.$moment.locale(this.initialSettings.language);
      switch (this.initialSettings.language) {
        case 'en':
          this.initialSettings.area = 'Main office';
          this.initialSettings.gatehouse = 'Gatehouse';
          break;
        case 'cs':
          this.initialSettings.area = 'Hlavní budova';
          this.initialSettings.gatehouse = 'Vrátnice';
          break;
      }
    },
    createWorkplace() {
      axios
        .get('/api/v1/uuid')
        .then((response) => {
          this.workplaceUUID = response.data.uuid;
          axios
            .post('/api/v1/workplace', {
              id: this.workplaceUUID,
              areas: [1],
              name: this.initialSettings.gatehouse,
              stayLoggedIn: true,
              cards: false,
              cardsList: false,
              cardsRequired: false,
              cars: true,
              carsList: true,
              carsRequired: false,
              expire: true,
              expireRequired: false,
              country: true,
              countryRequired: false,
              employee: true,
              employeeList: true,
              employeeRequired: false,
              company: true,
              companyList: true,
              companyRequired: false,
              defaultarea: 1,
              usrDef1: false,
              usrDef1Required: false,
              usrDef2: false,
              usrDef2Required: false,
              usrDef3: false,
              usrDef3Required: false,
              usrDef4: false,
              usrDef4Required: false,
              printGuestTicket: false,
              tranColumns: JSON.stringify([
                { name: 'Příchod', id: 2, text: 'Příchod', value: 'timeenter', align: 'left', width: '80' },
                { name: 'Odchod', id: 3, text: 'Odchod', value: 'timeexit', align: 'left', width: '80' },
                { name: 'Čas', id: 6, text: 'Čas', value: 'timeInObject', align: 'left', width: '80', sortable: false },
                { name: 'Jméno', id: 7, text: 'Jméno', value: 'name', align: 'left', width: '120' },
                { name: 'Příjmení', id: 8, text: 'Příjmení', value: 'surname', align: 'left', width: '120' },
                { name: 'Typ (dokladu)', id: 10, text: 'Typ', value: 'documenttype', align: 'left', width: '70' },
                { name: 'Prostor', id: 13, text: 'Prostor', value: 'area.name', align: 'left', width: '100' },
                { name: 'Za kým (Jméno)', id: 15, text: 'Zam.Jm.', value: 'employee.name', align: 'left', width: '100' },
                { name: 'Karta', id: 20, text: 'Karta', value: 'visitorcard.identifier', align: 'left', width: '100' },
              ]),
              prefillEmployee: true,
              prefillCompany: true,
              prefillCar: true,
              highlightDiffIDEnter: true,
              monitorDS: false,
              monitorQRS: false,
              monitorIRTS: false,
              statusDS: '',
              statusQRS: '',
              statusIRTS: '',
              versionDS: '',
              versionQRS: '',
              versionIRTS: '',
              report: 0,
              filterEmployees: true,
            })
            .then(() => {
              this.createClientDownloadURL();
              this.dialogDownloadClient = true;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    createClientDownloadURL() {
      let port = window.location.port;
      if (port === '') {
        window.location.protocol === 'http:' ? (port = '80') : (port = '443');
      }
      const url = window.location.protocol + `//` + window.location.hostname + `:` + port;
      this.clientDownloadLinkWindows = `/download/client/${this.workplaceUUID}/windows`;
      this.clientDownloadLinkMacIntel = `/download/client/${this.workplaceUUID}/mac-intel`;
      this.clientDownloadLinkMacAppleSilicon = `/download/client/${this.workplaceUUID}/mac-applesilicon`;
      this.clientDownloadServerURL = url;
    },
  },
});
</script>
